import * as React from "react";
const SvgCursor20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m1.259 1.259 17.327 6.664-6.358 2.89 6.48 6.48-1.415 1.414-6.48-6.48-2.89 6.359L1.26 1.259Zm3.482 3.482 3.336 8.673 1.668-3.67 3.67-1.667L4.74 4.74Z",
      clipRule: "evenodd"
    })
  );
export default SvgCursor20Px;
